export class setDefaultBioseal {
  static readonly type = "[BioSeal] set default BioSeal state";
  constructor() { }
}
export class setBioSealFormat {
  static readonly type = "[BioSeal] Update BioSeal Format";
  constructor(public payload: string) { }
}
export class setBioSealContentType {
  static readonly type = "[BioSeal] Update BioSeal Content type";
  constructor(public payload: boolean) { }
}
export class setBiometrics {
  static readonly type = "[BioSeal] Update BioSeal Biometrics";
  constructor(public payload: string) { }
}
export class setBioSealPersonalContent {
  static readonly type = "[BioSeal] Update BioSeal personal content";
  constructor(public payload: any) { }
}
export class setBioSealDocumentContent {
  static readonly type = "[BioSeal] Update BioSeal document content";
  constructor(public payload: any) { }
}
export class getBioSeal {
  static readonly type = "[BioSeal] get BioSeal ";
  constructor(public payload: any) { }
}
export class setContentDefault {
  static readonly type = "[BioSeal] set form content default ";
  constructor() { }
}
export class setBioSealPractitionerContent {
  static readonly type = "[BioSeal] Update  Practitioner content";
  constructor(public payload: any) { }
}
export class setBioSealTestContent {
  static readonly type = "[BioSeal] Update Test content";
  constructor(public payload: any) { }
}
export class setBioSealEventContent {
  static readonly type = "[BioSeal] Update Event content";
  constructor(public payload: any) { }
}
export class setDefaultResult {
  static readonly type = "[BioSeal] set default BioSeal result";
  constructor() { }
}
export class setPersonalFormSubmition {
  static readonly type = "[BioSeal] Update personal form submition status";
  constructor() { }
}
export class setDocumentFormSubmition {
  static readonly type = "[BioSeal] Update document form submition status";
  constructor() { }
}
export class setPractitionerFormSubmition {
  static readonly type = "[BioSeal] Update practitioner form submition status";
  constructor() { }
}
export class setTestFormSubmition {
  static readonly type = "[BioSeal] Update test form submition status";
  constructor() { }
}
export class setEventFormSubmition {
  static readonly type = "[BioSeal] Update event form submition status";
  constructor() { }
}